import { useEffect, useState } from "react";
import { History, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";

export function HistoricalAd({ horseId, ad }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!ad?.cover) return undefined;
    let url;
    api.get(`/horses/${horseId}/historical-cover`, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => {});
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [horseId, ad?.cover]);
  if (!ad) return null;
  return (
    <div data-testid="historical-ad" className="rounded-xl border border-stone-200 bg-white p-4 sm:p-5">
      <div className="flex items-center gap-2 text-sm font-semibold text-stone-900 mb-1"><History className="h-4 w-4 text-amber-800" />Historical Ad (old website) — preserved</div>
      <p className="text-xs text-stone-500 mb-3">Imported {new Date(ad.imported_at).toLocaleDateString()} · Bidding ended {ad.bidding_ends || "—"} · Shown under Completed on the website</p>
      <div className="flex flex-wrap gap-3 text-xs mb-3">
        {ad.facebook_post_url && <a data-testid="historical-ad-fb" href={ad.facebook_post_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 underline text-amber-800"><ExternalLink className="h-3 w-3" />Facebook post</a>}
        {ad.original_url && <a data-testid="historical-ad-original" href={ad.original_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 underline text-amber-800"><ExternalLink className="h-3 w-3" />Old website ad</a>}
      </div>
      {src && <img data-testid="historical-ad-cover" src={src} alt={`${ad.title} cover`} className="mb-3 max-h-64 rounded-lg object-cover" />}
      <h3 className="font-semibold text-stone-900">{ad.title}</h3>
      <p data-testid="historical-ad-text" className="mt-1 text-sm leading-relaxed text-stone-800 whitespace-pre-wrap">{ad.text}</p>
    </div>
  );
}
